export const InfoOutlined = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0068 16.8071C13.0189 17.3702 12.5656 17.8333 12.0023 17.8333C11.4393 17.8333 10.9862 17.3706 10.9979 16.8077V10.5368C11.0078 10.0624 11.5258 9.68353 12.0003 9.68353C12.4746 9.68353 12.9966 10.0626 13.0068 10.5368V16.8071Z"
        fill="#222222"
      />
      <path
        d="M11.1727 6.52733C11.4025 6.28686 11.6783 6.16662 12 6.16662C12.2121 6.16662 12.4048 6.22111 12.578 6.33007C12.7548 6.44279 12.8962 6.59309 13.0023 6.78096C13.1119 6.96883 13.1667 7.17736 13.1667 7.40656C13.1667 7.74473 13.05 8.03404 12.8167 8.27452C12.5869 8.51499 12.3147 8.63523 12 8.63523C11.6783 8.63523 11.4025 8.51499 11.1727 8.27452C10.9465 8.03404 10.8333 7.74473 10.8333 7.40656C10.8333 7.06088 10.9465 6.76781 11.1727 6.52733Z"
        fill="#222222"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M23.6667 12C23.6667 5.55664 18.4433 0.333291 12 0.333291C5.55669 0.333291 0.333344 5.55664 0.333344 12C0.333344 18.4433 5.55669 23.6666 12 23.6666C18.4433 23.6666 23.6667 18.4433 23.6667 12ZM21.9167 12C21.9167 6.52313 17.4768 2.08329 12 2.08329C6.52319 2.08329 2.08334 6.52313 2.08334 12C2.08334 17.4768 6.52319 21.9166 12 21.9166C17.4768 21.9166 21.9167 17.4768 21.9167 12Z"
        fill="#222222"
      />
    </svg>
  );
};

export const UploadIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 13V17C19 17.5304 18.7893 18.0391 18.4142 18.4142C18.0391 18.7893 17.5304 19 17 19H3C2.46957 19 1.96086 18.7893 1.58579 18.4142C1.21071 18.0391 1 17.5304 1 17V13M15 6L10 1M10 1L5 6M10 1V13"
        stroke="#4E84A1"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const InfoBlueOutlined = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99967 11.1668V8.50016M7.99967 5.8335H8.00634M14.6663 8.50016C14.6663 12.1821 11.6816 15.1668 7.99967 15.1668C4.31778 15.1668 1.33301 12.1821 1.33301 8.50016C1.33301 4.81826 4.31778 1.8335 7.99967 1.8335C11.6816 1.8335 14.6663 4.81826 14.6663 8.50016Z"
        stroke="#4E84A1"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const LocationIcon = () => {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.66667 6.83203C8.66667 8.30479 7.47276 9.4987 6 9.4987C4.52724 9.4987 3.33333 8.30479 3.33333 6.83203C3.33333 5.35927 4.52724 4.16536 6 4.16536C7.47276 4.16536 8.66667 5.35927 8.66667 6.83203ZM7.66667 6.83203C7.66667 7.75251 6.92048 8.4987 6 8.4987C5.07953 8.4987 4.33333 7.75251 4.33333 6.83203C4.33333 5.91156 5.07953 5.16536 6 5.16536C6.92048 5.16536 7.66667 5.91156 7.66667 6.83203Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.0189 13.7333C2.22812 12.3323 0.299397 9.80838 0 6.83203C0 3.51832 2.68629 0.832031 6 0.832031C9.31371 0.832031 12 3.51832 12 6.83203C11.703 9.78497 9.553 12.2926 6.96542 13.7C6.36097 14.0287 5.63384 14.0419 5.0189 13.7333ZM6.48762 12.8215C6.16965 12.9945 5.78857 13.0007 5.46753 12.8395C2.95396 11.5778 1.27726 9.34943 1.00024 6.78242C1.02686 4.04385 3.25513 1.83203 6 1.83203C8.74477 1.83203 10.973 4.04369 10.9998 6.78214C10.7258 9.29113 8.8638 11.5291 6.48762 12.8215Z"
        fill="white"
      />
    </svg>
  );
};
